import { Icon } from '@shopify/polaris';
import {
  CircleDownIcon,
  CircleRightIcon,
  CircleUpIcon,
  PackageFulfilledIcon,
  DeliveryIcon,
  CheckIcon,
  AlertTriangleIcon,
  PageClockIcon,
} from '@shopify/polaris-icons';
import { TrackingStatus } from '@/constants/email';

export const renderIconDirection = (changingValue: number) => {
  if (changingValue === 0) {
    return <Icon source={CircleRightIcon} tone="info" />;
  }
  if (changingValue > 0) {
    return <Icon source={CircleUpIcon} tone="success" />;
  }
  return <Icon source={CircleDownIcon} tone="critical" />;
};

const getTrackingStatusConfig = (status: TrackingStatus) => {
  switch (status) {
    case TrackingStatus['Information received']:
      return {
        icon: PackageFulfilledIcon,
        background: '#EAF4FF',
        color: '#0094D5',
      };
    case TrackingStatus['In transit']:
      return {
        icon: DeliveryIcon,
        background: '#EAF4FF',
        color: '#0094D5',
      };
    case TrackingStatus['Out for Delivery']:
      return {
        icon: DeliveryIcon,
        background: '#EAF4FF',
        color: '#0094D5',
      };
    case TrackingStatus['Available for Pickup']:
      return {
        icon: CheckIcon,
        background: '#CDFEE1',
        color: '#29845A',
      };
    case TrackingStatus.Delivered:
      return {
        icon: CheckIcon,
        background: '#CDFEE1',
        color: '#29845A',
      };
    case TrackingStatus['Failed Attempt']:
      return {
        icon: DeliveryIcon,
        background: '#FFF8DB',
        color: '#998A00',
      };
    case TrackingStatus.Exception:
      return {
        icon: AlertTriangleIcon,
        background: '#FFF8DB',
        color: '#998A00',
      };
    case TrackingStatus.Expired:
      return {
        icon: PageClockIcon,
        background: '#FFF1E3',
        color: '#B28400',
      };
    default:
      return {
        icon: PageClockIcon,
        background: '#E3E3E3',
        color: '#4A4A4A',
      };
  }
};

export const renderTrackingStatusIcon = (status: TrackingStatus) => {
  const config = getTrackingStatusConfig(status);

  return (
    <div
      style={{
        width: '24px',
        height: '24px',
        borderRadius: '50%',
        backgroundColor: config.background,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}
    >
      <div style={{ color: config.color }}>
        <Icon source={config.icon} tone="base" />
      </div>
    </div>
  );
};
